import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setMessage } from 'src/store/Message';
import VersionHistory from 'src/components/common/VersionHistory';
import { archLevel } from 'src/data/config';
import { DataTable } from '@pihealth/common-ui-library';
import SiteQualitficationFollowupLetter from './SiteQualitficationFollowupLetter';
import staticData from '../../../../resources/static.json';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useSqFollowupLetter } from './useSqFollowupLetter';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
export default function DataGridSQFollowUpLetter(props: any) {
  const { siteStudyData, setSqFollowupLetterOpen, setStudyLogOpen } = props;
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const [headerTitle, setHedertitle] = useState('');
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState('');
  const dispatch = useAppDispatch();
  const assignedColoumns = staticData.SQLetters.columns;
  const [openSQFollowLetter, setOpenSQFollowLetter] = useState(false);
  const [viewNTFGrid, setNTFGrid] = useState(true);
  const [rows, setRows] = useState([]);
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();
  const [sqvisitData, setSqvisitData] = useState({} as any);

  const { getSqFollowupLetter, sqFollowupLetterData, sqFollowupLetterIsLoading } = useSqFollowupLetter();

  useEffect(() => {
    if (checkPermission('view_sq_followupletter') && viewNTFGrid) {
      getSqFollowupLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry
      });
    }
  }, [viewNTFGrid, selectedSite, selectedCountry]);

  useEffect(() => {
    if (sqFollowupLetterData) {
      setSqvisitData(sqFollowupLetterData);
      setRows(
        sqFollowupLetterData?.map((item: any) => {
          return {
            ...item,
            major_version: Number(item.major_version).toFixed(1).toString(),
            updated_on: getPreferredDateTimeInLocal(item.updated_on),
            start_date: getPreferredDateTimeInLocal(item.start_date)
          };
        })
      );
    }
  }, [sqFollowupLetterData]);

  const handelBack = () => {
    setStudyLogOpen(true);
  };

  const [selectedRow, setselectedRow] = useState<any>(null);

  useEffect(() => {
    if (selectedSite === null) {
      handelBack();
    }
  }, [studyId, selectedCountry, selectedSite]);

  const handleClick = (row: any) => {
    if (archLevel === 'site') {
      if (checkPermission('publishview_siqualifi_followupletter')) {
        if (row.major_version === '0.0') {
          dispatch(setMessage({ msgDetails: `${row.visit_name} not yet published`, severity: 'error' }));
        } else {
          if (!isHierarchyLevelClosed) {
            setOpenSQFollowLetter(true);
            setNTFGrid(false);
            setselectedRow(row);
          } else {
            dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
          }
        }
      } else {
        dispatch(setMessage({ msgDetails: `Do not have required permission to view the letter`, severity: 'error' }));
      }
    } else {
      if (!isHierarchyLevelClosed) {
        setOpenSQFollowLetter(true);
        setNTFGrid(false);
        setselectedRow(row);
      } else {
        dispatch(setMessage({ msgDetails: 'Please select the site', severity: 'error' }));
      }
    }
  };
  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };

  const actions = {
    visit_name: (data: any) => {
      handleClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`SQ Follow Up Letters`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };

  return (
    <div>
      {viewNTFGrid ? (
        <>
            <Box sx={{ marginBottom: 1, mt: -1 }}>
              <Button
                className="mainBackBtnWrap"
                onClick={() => handelBack()}
                startIcon={<ArrowBackIcon fontSize="small" />}
              >
                LIST OF LOGS
              </Button>
            </Box>

          <div style={{ height: '74vh', width: '100%' }}>
            <div style={{ display: 'flex', height: '100%' }}>
              <div style={{ flexGrow: 1 }}>
                <DataTable
                  columns={assignedColoumns}
                  rows={rows}
                  loading={sqFollowupLetterIsLoading}
                  disableSelectionOnClick={false}
                  pagination
                  className="studylogDatagrid"
                  exportAll
                  actions={actions}
                  datePreference={userPreferedDateFormat}
                  height="74vh"
                  hasDefinedDataGridToolbarExport
                  definedGridToolbarExport={definedCustomDatGridExport}
                />
              </div>
            </div>
          </div>
        </>
      ) : null}

      {openSQFollowLetter ? (
        <SiteQualitficationFollowupLetter
          siteStudyData={siteStudyData}
          sqvisitData={sqvisitData}
          setSqFollowupLetterOpen={setSqFollowupLetterOpen}
          setStudyLogOpen={setStudyLogOpen}
          setOpenSQFollowLetter={setOpenSQFollowLetter}
          setNTFGrid={setNTFGrid}
          selectedRow={selectedRow}
        />
      ) : null}
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'STUDY LOGS'}
        />
      ) : null}
    </div>
  );
}
